export default "__VITE_ASSET__Cl23L4pb__"